import React from 'react';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import { MediaGallery } from 'ui/MediaGallery';
import { ItineraryTypes } from '../types';

export interface iItemMediaProps {
  vimeoVideoId?: string;
  uploads: ItineraryTypes['ItineraryImageUploadOrThumbnail'][];
  titleForModal: string;
}

/**
 * ItemMedia - Backwards compatibility wrapper for itinerary system
 * Re-exports MediaGallery with itinerary-specific base URL
 */
export const ItemMedia = (props: iItemMediaProps) => {
  const params = useDynamicParameters();
  const { ITINERARY_MANAGER_BASE_URL } = params.dynamicParameters;

  return (
    <MediaGallery
      uploads={props.uploads}
      titleForModal={props.titleForModal}
      baseUrlPath={`${ITINERARY_MANAGER_BASE_URL}/viewer/v1/media/`}
      vimeoVideoId={props.vimeoVideoId}
    />
  );
};
